export default __webpack_public_path__ + "98b9e40782930867e5c92251513b1ad7.svg";